import { http } from "../../../shared/api/http"

export type MarketCategory = {
  id: string
  codename: string
  parent_id?: string | null
  order: number
  has_children?: boolean
}

export type MarketCategoryListResponse = {
  items: MarketCategory[]
}

export const listRootMarketCategoriesApi = () =>
  http.get<MarketCategoryListResponse>("/api/china/market-categories")

export const listMarketCategoryChildrenApi = (categoryId: string) =>
  http.get<MarketCategoryListResponse>(`/api/china/market-categories/${categoryId}/children`)

export const getMarketCategoryApi = (categoryId: string) =>
  http.get<MarketCategory>(`/api/china/market-categories/${categoryId}`)

export type CreateMarketCategoryPayload = {
  codename: string
  parent_id?: string | null
  order?: number
}

export const createMarketCategoryApi = (data: CreateMarketCategoryPayload) =>
  http.post<MarketCategory>("/api/china/market-categories", data)

export const deleteMarketCategoryApi = (categoryId: string) =>
  http.delete<{ success: boolean }>(`/api/china/market-categories/${categoryId}`)